import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { ICashRegister } from '../interfaces';
import { CashRegisterMapper } from '../mappers';

export type IGetCashRegisterRepoData = { data: ICashRegister[]; total: number };

export type IGetCashRegisterRepoResponse = IRepoResponse<200, IGetCashRegisterRepoData> | IRepoResponse<400 | 500, string>;

export type IGetCashRegisterRepo = IRepo<[any], IGetCashRegisterRepoResponse>;

export const GetCashRegisterRepoType = Symbol.for('GetCashRegistersRepo');

@bind(GetCashRegisterRepoType)
export class GetCashRegistersRepo implements IGetCashRegisterRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/cashboxes', query) });

      if (result.status === 200) {
        const data: ICashRegister[] = result.data.data.map((user) => CashRegisterMapper.toDomain(user));
        const total: number = result.data.total;

        return { status: 200 as 200, response: { data, total } };
      } else {
        return { status: 400 as 400, response: 'Məlumatlar əldə edilə bilmədi' };
      }
    } catch (e) {
      return { status: 500 as 500, response: 'Şəbəkə ilə əlaqə qurula bilmədi' };
    }
  }
}
